import { DB_PREFIX } from './constants';

export default {
  [DB_PREFIX]: {
    dateTimeAvailable: {},
    hourRate: { 0: 10, 1: 50 },
    travelOptions: null,
  },
};
